module.exports = __webpack_public_path__ + "static/img/user-comment6.57fc0d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/user-comment6.png
// module id = ChsH
// module chunks = 0